import img from '/static/img/bookNow/provide/img.png'
const provideInfo = {
    title:'Provide You With',
    img:img,
    descList:[
        {
            id:1,
            desc:'Top Exclusive Experiences: We have exclusive airport lounges and the most personalized service for a unique experience!'
        },
        {
            id:2,
            desc:'Unique Experiences: Our team digs out niche itineraries for you.'
        },
        {
            id:3,
            desc:'Expertise: We\'ll organize all your plans the way you like them, and our experienced travel consultants help you explore your pursuits.'
        }
    ]
}
export default{
    provideInfo
}